import { useState } from "react";
import { X, Smartphone } from "lucide-react";
import { SITE } from "@/lib/config";
import { useLang } from "@/lib/i18n";
import { trackEvent } from "@/lib/analytics";

export const AnnouncementBar = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(() => window.sessionStorage.getItem("tijuas-announce") !== "closed");
  if (!open) return null;
  const dismiss = () => { window.sessionStorage.setItem("tijuas-announce", "closed"); setOpen(false); };
  return (
    <div className="bg-hacienda-charcoal text-hacienda-cream" role="region" aria-label="Announcement" data-testid="announcement-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-center gap-3 text-sm">
        <Smartphone size={16} className="text-hacienda-amber flex-shrink-0" aria-hidden="true" />
        <p className="text-center">
          <span className="hidden sm:inline">{t("announcement.text")}</span>
          <span className="sm:hidden">{t("announcement.text").split("—")[0]}</span>
          {" "}
          <a
            href={SITE.appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("app_download_click", { location: "announcement" })}
            className="font-semibold text-hacienda-amber underline underline-offset-4 hover:text-white transition-colors"
            data-testid="announcement-app-link"
          >
            {t("announcement.cta")} →
          </a>
        </p>
        <button onClick={dismiss} aria-label={t("actions.close")} className="ml-2 p-1 rounded hover:bg-white/10 transition-colors" data-testid="announcement-close">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};
